import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  min3,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ComponentCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // user: {},
      loading: false,
      components: []
    };
    this.send = this.send.bind(this);
    this.update = this.update.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    axios
      .get(`${URL.api}configuration/link/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState(
          {
            components: resp.data.data
          },
          () => {
            const { id } = this.props.match.params;
            if (id) {
              let { components } = this.state;
              this.setState(
                () => ({
                  loading: true,
                  components: []
                }),
                () => {
                  let componetWhidoutMe = [];
                  components.forEach(elem => {
                    if (parseInt(id) !== elem.id) {
                      componetWhidoutMe.push(elem);
                    }
                  });
                  axios
                    .get(`${URL.api}configuration/link/singleView/${id}`, {
                      headers: {
                        authorization: `Bearer ${this.props.user.token}`
                      }
                    })
                    .then(resp => {
                      if (resp.data.success) {
                        this.setState(
                          () => ({
                            component: resp.data.data,
                            components: componetWhidoutMe
                          }),
                          () => {
                            this.setState(() => ({
                              edit: true,
                              loading: false
                            }));
                          }
                        );
                      }
                    });
                }
              );
            }
          }
        );
      });
  }

  send(value) {
    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      path: value.path,
      url: value.url,
      component: value.component,
      exact: "true",
      local: value.local
    };
    axios
      .post(`${URL.api}configuration/link/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/component/list");
      });
  }

  update(value) {
    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      path: value.path,
      url: value.url,
      component: value.component,
      exact: "true",
      local: value.local
    };
    axios
      .post(`${URL.api}configuration/link/update/${value.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/component/list");
      });
  }

  render() {
    const Fields = [
      {
        name: "name",
        label: "Name -  Ex.: Component List",
        type: "text",
        required: true,
        icon: "fa fa-user",
        validate: [required, min3, alphaNumeric]
      },
      {
        name: "path",
        label: "Path - Ex.: /component/list",
        type: "text",
        required: true,
        icon: "fa fa-user"
      },
      {
        name: "url",
        label: "Url - Ex.: /component/list",
        type: "text",
        required: true,
        icon: "fa fa-user"
      },
      {
        name: "component",
        label: "Component Ex.: ComponentList",
        type: "text",
        required: true,
        icon: "fa fa-user"
      },
      {
        name: "local",
        label: "Local - Ex.: configuration/component/list/list",
        type: "text",
        required: true,
        icon: "fa fa-user"
      },
      {
        name: "link_id",
        label: "Selecione Componente pai",
        type: "select",
        required: true,
        icon: "fa fa-user",
        options: this.state.components
      }
    ];
    let buttons = [
      {
        name: "Enviar",
        submit: false,
        icon: "fa fa-cloud",
        iconSide: "left",
        custom: this.enviar,
        color: "primary"
      }
    ];
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/component/list", to: "/component/list" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Form
            fields={Fields}
            buttons={buttons}
            onSubmit={this.state.edit ? this.update : this.send}
            initialValues={this.state.component}
            edit={this.state.edit}
            back
            history={this.props.history}
          />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ComponentCreate);
